const TextWithBreaks = ({ text }) => {
  if (!text) return null;
  const textParts = text.split(/\r\n|\n/);

  return (
    <div>
      {textParts.map((part, index) => (
        <div key={index}>
          {part}
          <br />
        </div>
      ))}
    </div>
  );
};

export default TextWithBreaks;
